export default "__VITE_ASSET__915ea4d1__"